module.exports = global["jQuery"] = require("-!C:\\Users\\Q707296\\source\\repos\\spotfire-visuals\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");